import React, { useState } from 'react';
import { Form } from 'react-final-form';
import FontawesomeIcon from '@fortawesome/react-fontawesome';

import {
  composeValidators,
  required,
  mustBeNumber,
  lengthRange,
} from 'utils/formValidators';
import CustomToolTip from 'components/tooltip/customToolTip';
import FormField from 'components/Form/FormField';

const LocationCodeEditForm = ({ onSubmit, onCancel, locationCode }) => {
  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{ locationCode }}
      render={({ handleSubmit, form, submitting }) => (
        <form
          name="businessLocationCodeForm"
          className="row"
          onSubmit={handleSubmit}
        >
          <FormField
            name="locationCode"
            label="Location Code:"
            containerClassName="form-group col-12 col-md-3"
            inputClassName="form-control"
            validate={composeValidators(
              required,
              mustBeNumber,
              lengthRange(4, 6)
            )}
          />
          <div className="col-12 col-md-3 mt-md-4 pt-md-3">
            <FontawesomeIcon
              className="cancel-icon"
              icon="times"
              onClick={() => {
                onCancel();
              }}
            />
            <FontawesomeIcon
              className="save-icon"
              icon="check"
              onClick={handleSubmit}
            />
          </div>
        </form>
      )}
    />
  );
};

const LocationCode = ({ locationCode, onSubmit }) => {
  const [isEditing, setIsEditing] = useState(false);
  const handleSubmit = values => {
    onSubmit(values);
    setIsEditing(false);
  };

  if (isEditing) {
    return (
      <LocationCodeEditForm
        locationCode={locationCode}
        onSubmit={handleSubmit}
        onCancel={() => setIsEditing(false)}
      />
    );
  }

  return (
    <React.Fragment>
      <span className="thin-font-weight">Location Code: </span>
      {locationCode}{' '}
      <CustomToolTip
        target="locationCode"
        toolTipText="Edit Location Code"
        icon="pencil-alt"
        iconClassName="hover-edit-btn"
        onClick={() => setIsEditing(true)}
      />
    </React.Fragment>
  );
};

export default LocationCode;



// WEBPACK FOOTER //
// ./src/components/businessDetail/businessLocation/locationCode.js